import type {FC} from 'react';
import {observer} from 'mobx-react';
import {Chip, Icon, IconNames} from '@wellstone-solutions/web';
import type {UIResourceType} from '@wellstone-solutions/common/models/rest';
import {useStores} from 'hooks/useStores';

interface FlagSentProps {
  resource: UIResourceType;
}

export const FlagSent: FC<FlagSentProps> = observer(({resource}) => {
  const {resourceStoreV2} = useStores();

  if (!resourceStoreV2.isResourceFlagged(resource)) {
    return null;
  }

  return (
    <Chip
      size="small"
      variant="outlined"
      label="Flag sent"
      icon={<Icon name={IconNames.TriangleFlag} size={14} />}
      sx={styles.chip}
    />
  );
});

const styles = {
  chip: {
    color: 'text.secondary',
    borderColor: 'divider',
    '& .MuiChip-icon': {color: 'inherit', ml: 0.75},
  },
};
